export interface CasConfig {
    casServer: string; // URL del servidor CAS
    service: string;   // URL del cliente que recibirá el ticket
  }
  
  export interface User {
    username: string;
    [key: string]: any; // Otros atributos personalizados del usuario
  }

  export function CreateUser(usuario: string):User{
    return{
      username: usuario
    }    
  }
  
  export interface CasContextType {
    user: User | null;
    isAuthenticated: boolean;
    login: () => void;
    logout: () => void;
  }
  